import React from 'react';
import { TrendingUp, UserPlus, Trophy } from 'lucide-react';

/** Decorative product-style dashboard preview built with Tailwind (illustrative, not real data). */
const bars = [38, 52, 44, 66, 58, 78, 92];
const stages = [
  { name: 'New', w: 'w-full', c: 'bg-blue-200' },
  { name: 'Qualified', w: 'w-4/5', c: 'bg-blue-400' },
  { name: 'Proposal', w: 'w-3/5', c: 'bg-blue-600' },
  { name: 'Won', w: 'w-2/5', c: 'bg-brand-accent' },
];

const DashboardMock = () => (
  <div className="relative">
    <div className="rounded-3xl bg-white border border-slate-200 shadow-2xl shadow-slate-900/10 overflow-hidden">
      <div className="flex items-center gap-2 px-5 py-3 border-b border-slate-100 bg-slate-50">
        <span className="w-3 h-3 rounded-full bg-slate-300" />
        <span className="w-3 h-3 rounded-full bg-slate-300" />
        <span className="w-3 h-3 rounded-full bg-slate-300" />
        <span className="ml-3 text-xs font-medium text-slate-400">Insigrow · Dashboard</span>
      </div>

      <div className="p-6 space-y-5">
        <div className="grid grid-cols-3 gap-3">
          {[
            { icon: UserPlus, label: 'New leads', tone: 'text-blue-600 bg-blue-50' },
            { icon: TrendingUp, label: 'Conversion', tone: 'text-emerald-600 bg-emerald-50' },
            { icon: Trophy, label: 'Deals won', tone: 'text-blue-600 bg-blue-50' },
          ].map(({ icon: Icon, label, tone }) => (
            <div key={label} className="rounded-xl border border-slate-200 p-3">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center mb-2 ${tone}`}>
                <Icon className="w-4 h-4" />
              </div>
              <div className="text-xs text-slate-500">{label}</div>
              <div className="mt-1 h-2.5 w-12 rounded bg-slate-200" />
            </div>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          <div className="rounded-xl border border-slate-200 p-4">
            <div className="text-xs font-semibold text-slate-500 mb-3">Revenue trend</div>
            <div className="flex items-end gap-2 h-24">
              {bars.map((h, i) => (
                <div
                  key={i}
                  style={{ height: `${h}%` }}
                  className={`flex-1 rounded-t-md ${i === bars.length - 1 ? 'bg-brand-accent' : 'bg-blue-200'}`}
                />
              ))}
            </div>
          </div>
          <div className="rounded-xl border border-slate-200 p-4">
            <div className="text-xs font-semibold text-slate-500 mb-3">Pipeline</div>
            <div className="space-y-2.5">
              {stages.map((s) => (
                <div key={s.name} className="flex items-center gap-2">
                  <span className="text-[11px] text-slate-500 w-14">{s.name}</span>
                  <div className="flex-1 h-2.5 bg-slate-100 rounded-full">
                    <div className={`h-full rounded-full ${s.w} ${s.c}`} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="hidden sm:flex absolute -bottom-10 -left-8 items-center gap-3 bg-white rounded-2xl border border-slate-200 shadow-xl px-4 py-3">
      <span className="w-10 h-10 rounded-full bg-emerald-50 flex items-center justify-center">
        <Trophy className="w-5 h-5 text-emerald-600" />
      </span>
      <div>
        <div className="text-sm font-bold text-slate-900">Deal won</div>
        <div className="text-xs text-slate-500">Invoice ready to send</div>
      </div>
    </div>
  </div>
);

export default DashboardMock;
